import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";

const FLEET = [
    {
        id: "wms-aurora",
        name: "MV Windermere Aurora",
        category: "Bulk Carrier",
        image: "https://images.unsplash.com/photo-1673170705689-abc04a056a88?crop=entropy&cs=srgb&fm=jpg&q=85",
        specs: { DWT: "82,500 MT", LOA: "229 m", Year: "2019", Flag: "Singapore" },
    },
    {
        id: "wms-meridian",
        name: "MT Windermere Meridian",
        category: "Product Tanker",
        image: "https://images.unsplash.com/photo-1746481594820-04358d2055cd?crop=entropy&cs=srgb&fm=jpg&q=85",
        specs: { DWT: "49,800 MT", LOA: "183 m", Year: "2021", Flag: "Singapore" },
    },
    {
        id: "wms-orion",
        name: "OSV Windermere Orion",
        category: "Offshore Support",
        image: "https://images.unsplash.com/photo-1595936398510-7057e9288156?crop=entropy&cs=srgb&fm=jpg&q=85",
        specs: { BHP: "8,200", LOA: "75 m", Year: "2020", Flag: "Singapore" },
    },
    {
        id: "wms-northstar",
        name: "MV Windermere Northstar",
        category: "Container Vessel",
        image: "https://images.unsplash.com/photo-1713859288954-3314e2fcaa7a?crop=entropy&cs=srgb&fm=jpg&q=85",
        specs: { TEU: "4,300", LOA: "260 m", Year: "2022", Flag: "Singapore" },
    },
];

export default function FleetShowcase({ compact = false }) {
    return (
        <section data-testid="fleet-showcase" className={`relative ${compact ? "py-16" : "py-24 md:py-32"} bg-[#040914]`}>
            <div className="wms-container">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
                    <div className="max-w-2xl">
                        <span className="wms-overline">Fleet — 04</span>
                        <h2 className="mt-5 font-display font-light text-4xl md:text-5xl leading-tight tracking-tight">
                            Modern, multi-segment, <span className="italic text-[#48CAE4]">classed worldwide.</span>
                        </h2>
                    </div>
                    <Link
                        to="/fleet"
                        data-testid="fleet-cta"
                        className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.22em] text-white/70 hover:text-white"
                    >
                        Browse full fleet <ArrowUpRight size={16} weight="bold" />
                    </Link>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-12 gap-px bg-white/5 border border-white/5">
                    {FLEET.map((v, i) => (
                        <motion.article
                            key={v.id}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-50px" }}
                            transition={{ duration: 0.6, delay: i * 0.06 }}
                            data-testid={`fleet-card-${v.id}`}
                            className={`relative bg-[#040914] overflow-hidden group ${
                                i === 0 ? "lg:col-span-7" : i === 1 ? "lg:col-span-5" : i === 2 ? "lg:col-span-5" : "lg:col-span-7"
                            }`}
                        >
                            <div className="aspect-[4/3] relative overflow-hidden">
                                <img
                                    src={v.image}
                                    alt={v.name}
                                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#040914] via-[#040914]/30 to-transparent" />
                                <span className="absolute top-4 left-4 wms-glass px-3 py-1 text-[10px] tracking-[0.28em] uppercase">
                                    {v.category}
                                </span>
                            </div>
                            <div className="p-7 flex flex-col gap-5">
                                <div className="flex items-end justify-between gap-4">
                                    <h3 className="font-display text-2xl text-white leading-tight">{v.name}</h3>
                                    <span className="text-[10px] tracking-[0.32em] uppercase text-white/40 whitespace-nowrap">IMO · WMS-{i + 100}</span>
                                </div>
                                <dl className="grid grid-cols-4 gap-3 text-center border-y border-white/5 py-4">
                                    {Object.entries(v.specs).map(([k, val]) => (
                                        <div key={k}>
                                            <dt className="text-[9px] tracking-[0.28em] uppercase text-white/40">{k}</dt>
                                            <dd className="mt-1 font-display text-sm text-white">{val}</dd>
                                        </div>
                                    ))}
                                </dl>
                            </div>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}
